import { checkingPreload, unCheckingPreload } from '../loading';
import {
  setAssistantsListRedux,
  setAssistantRedux,
  setFormOptionsRedux,
  setFormOptionsIaSkillsRedux,
  setPlanInfoRedux,
} from './assistantsSlice';
import {
  getAllAssistantsService,
  getAssistantByIdService,
  createAssistantService,
  updateAssistantService,
  deleteAssistantService,
  restoreAssistantService,
  getAssistantsFormOptionsService,
} from '../../services/assistants.service';
import { QueryPagination } from '../../commons/interfaces';

export const getDataFormDropDownStore = () => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await getAssistantsFormOptionsService();
    if (response?.ok) {
      dispatch(setFormOptionsRedux(response.data.services));
      dispatch(setFormOptionsIaSkillsRedux(response.data.iaSkills));
      dispatch(setPlanInfoRedux(response.data.planInfo));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const getAllAssistantsStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await getAllAssistantsService(query);
      if (response.ok) {
        dispatch(setAssistantsListRedux(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getAssistantByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await getAssistantByIdService(id);
    if (response?.ok) {
      dispatch(setAssistantRedux(response.data));
      dispatch(setFormOptionsIaSkillsRedux(response.data.iaSkills));
      if (response.data?.services) {
        dispatch(setFormOptionsRedux(response.data.services));
      }
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const saveAssistantStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await createAssistantService(data);
    if (response.ok) {
      dispatch(setAssistantsListRedux(response.data));
    }
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const editAssistantStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());
  try {
    const response = await updateAssistantService(id, data);
    return response;
  } catch (error) {
    console.error(error);
    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deleteAssistantStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await deleteAssistantService(id, query);
      if (response.ok) {
        dispatch(setAssistantsListRedux(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreAssistantStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());
    try {
      const response = await restoreAssistantService(id, query);
      if (response.ok) {
        dispatch(setAssistantsListRedux(response.data));
      }
      return response;
    } catch (error) {
      console.error(error);
      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
